import { clsx } from 'clsx';
import type { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind class names, with later classes winning conflicts.
 *
 * `twMerge` on top of `clsx` so that a component's own `className` prop can
 * override a base class rather than both landing in the class list and the
 * outcome depending on stylesheet order.
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
